<template>
    <!-- <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" data-testid="directions-74" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Search Filter</ion-title>
        <ion-buttons slot="end">
            <ion-button data-testid="directions-75" @click="reset">
                <span>Reset</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar> -->

    <div class="main_wrapper ion-padding">
        <el-button class="reset-button" @click="reset">Reset</el-button>
        <!-- <div class="search-bar">
            <img src="@/assets/img/job-seeker/jam_search.svg" class="search-icon" height="20" alt="Search" />
            <el-input data-testid="directions-76" v-model="selectedValues.text" class="job-board__search"
                placeholder="Search" clearable @clear="clearText">
            </el-input>
            <button class="filter-button">
                <img src="@/assets/img/job-seeker/setting-active.svg" />
            </button>
        </div> -->
        <div v-if="loading">
            <JobListingFilterSkeleton :skeletonCount="1" />
        </div>
        <div v-else>
            <div v-if="isFilterOptionsVisible" class="filter-options">
                <div class="filter-type">
                    <h3 class="filter-title">Filter by Job Type</h3>
                    <div class="filter-item">
                        <div class="filter-select" v-for="(type, index) in jobTypes" :key="index">
                            <input data-testid="directions-77" type="radio" name="type" :id="'jobType-' + index"
                                v-model="selectedValues.jobType" :value="type.title">
                            <label :for="'jobType-' + index">{{ type.title }}</label>
                        </div>
                    </div>
                </div>
                <div class="filter-type">
                    <h3 class="filter-title">Filter by Job Location</h3>
                    <!-- <div class="filter-item" v-if="isAustralia">
                        <div class="filter-select" v-for="(location, index) in jobLocations" :key="index">
                            <input data-testid="directions-78" type="radio" name="location" :id="'location-' + index"
                                v-model="selectedValues.jobLocation" :value="location.name">
                            <label :for="'location-' + index">{{ location.name }}</label>
                        </div>
                    </div> -->
                    <div class="filter-item el-input">
                        <vue-google-suburb-autocomplete-for-job-post-filter
                            data-testid="directions-102" 
                            id="map" 
                            classname="el-input__inner"
                            v-model="selectedValues.jobLocation"
                            placeholder="Find your city and state" 
                            v-on:placechanged="updateAddressData"
                            @keyup="setAddress"
                            :initial-location="selectedValues.jobLocation"
                            :country="countryArray"
                        />
                    </div>
                </div>
                <div class="filter-type" v-if="isUS">
                    <h3 class="filter-title">Filter by distance from location</h3>
                    <div class="filter-item">
                        <el-input
                            v-model="selectedValues.distanceFromLocation"
                            type="number"
                            placeholder="Distance (Miles)"
                            data-testid="directions-distance"
                            :disabled="!selectedValues.jobLocation || selectedValues.jobLocation.trim() === ''"
                        />
                    </div>
                </div>

                <div class="filter-type" v-if="isAustralia">
                    <h3 class="filter-title">Filter by distance from location</h3>
                    <div class="filter-item">
                        <el-input
                            v-model="selectedValues.distanceFromLocation"
                            type="number"
                            placeholder="Distance (KM)"
                            data-testid="directions-distance"
                            :disabled="!selectedValues.jobLocation || selectedValues.jobLocation.trim() === ''"
                        />
                    </div>
                </div>

                <div class="filter-type">
                    <h3 class="filter-title">Tagged Skills</h3>
                    <div class="filter-item">
                        <div class="filter-select" v-for="(skill, index) in taggedSkills" :key="index">
                            <input data-testid="directions-79" type="checkbox" name="tagged-skills"
                                :id="'skill-' + index" v-model="selectedValues.taggedSkills" :value="skill.name">
                            <label :for="'skill-' + index">{{ skill.name }} </label>
                        </div>
                    </div>
                </div>
                <div class="filter-type" v-if="isUS">
                    <h3 class="filter-title">Filter by Federal Pharmacist Support
                    </h3>
                    <div class="filter-item">
                        <div class="filter-select" v-for="(type, index) in federalPharmacistSupport" :key="index">
                            <input data-testid="directions-77" type="radio" name="type" :id="'federalPharmacistSupport-' + index"
                                v-model="selectedValues.federalPharmacistSupport" :value="type">
                            <label :for="'federalPharmacistSupport-' + index">{{ type }}</label>
                        </div>
                    </div>
                </div>
            </div>
            <el-form-item class="button_submit mb0">
                <el-button class="submit" type="blue" data-testid="directions-80" @click="goSearch">
                    Apply
                </el-button>
            </el-form-item>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, computed, watch, defineEmits } from 'vue';
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import JobListingFilterSkeleton from "@/components/JobListingSkeleton/JobListingFilterSkeleton.vue";
// import RangeSlider from "@/components/RangeSlider/RangeSlider.vue";
import { isAustraliaRegion, isUSRegion } from '@/helpers/region/regionHelper.js';
import { VueGoogleSuburbAutocompleteForJobPostFilter } from "@/components/components";


// const props = defineProps({
//   modalCreateVisible: {
//     type: Boolean,
//     required: true,
//   },
// });

const $store = useStore();
const $router = useRouter();
const isFilterOptionsVisible = ref(true);
const currentRouteName = ref(null);
const selectedValues = ref({
    text: '',
    jobType: '',
    jobLocation: '',
    latitude: '',
    longitude: '',
    taggedSkills: [],
    federalPharmacistSupport: '',
    rate: {
        type: '',
        value: 0
    },
    distanceFromLocation: ''

});
const loading = ref(false);
const jobTypes = ref([]);
const jobLocations = ref([]);
const taggedSkills = ref([]);
const federalPharmacistSupport= ref([]);
const sliderValue = ref(null);
const isAustralia = isAustraliaRegion();
const isUS = isUSRegion();
const rateType = ref("");
const emit = defineEmits(['update:modalCreateVisible']);
// Function to reset filters
const reset = () => {
    localStorage.removeItem('jobLisitingGuestBrowseFilterObject');
    selectedValues.value = {
        text: '',
        jobType: '',
        jobLocation: '',
        latitude: '',
        longitude: '',
        taggedSkills: [],
        federalPharmacistSupport: '',
        rate: {
            type: '',
            value: 0
        },
        distanceFromLocation: ''
    };
    rateType.value = "";
}


const countryArray = computed(() => {
    const region = process.env.VUE_APP_REGION;
    if (region === 'US') return ['us'];
    if (region === 'AU') return ['au'];
    return []; // Default or empty if region is not recognized
});

// function handleSliderChange(event) {
//     console.log("🚀 ~ handleSliderChange ~ event:", rateType.value)
//     if (rateType.value === "") {
//         console.log("iamkhali")
//         rateType.value = "hourly";
//     }
//     console.log("🚀 ~ handleSliderChange ~ after:", rateType.value)
//     const numericValue = parseFloat(event.target.value);
//     sliderValue.value = event.target.value; // Updating parent value with the value emitted from child
//     selectedValues.value.rate.value = numericValue;
// }


// Watch for changes in rateType
watch(rateType, (newValue) => {
    console.log("🚀 ~ watch ~ newValue:", newValue)
    selectedValues.value.rate.type = newValue; // Update selectedValues object

});
// Computed property to determine slider configuration based on rateType
// const sliderConfig = computed(() => {
//     if (rateType.value === 'hourly') {
//         return {
//             min: 0,
//             max: 200,
//             initialValue: sliderValue.value ? sliderValue.value : 20
//         };
//     } else if (rateType.value === 'annual') {
//         return {
//             min: 200,
//             max: 200000,
//             initialValue: sliderValue.value ? sliderValue.value : 20000
//         };
//     } else {
//         // Default values in case rateType is not set
//         return {
//             min: 0,
//             max: 200,
//             initialValue: sliderValue.value ? sliderValue.value : 20
//         };
//     }
// });


// Function to navigate back
// const goBack = () => {
//     currentRouteName.value = $router.currentRoute.value.name;
//     console.log("🚀 ~ setup ~ currentRouteName.value:", currentRouteName.value)
//     $store.dispatch('PREVIOUS_ROUTE_NAME', currentRouteName.value);

//     $router.push({
//         name: "job_seeker_index",
//     });
// };

// Function to perform search
const goSearch = () => {
    // Save selected values to local storage
    localStorage.setItem('jobLisitingGuestBrowseFilterObject', JSON.stringify(selectedValues.value));

    // Perform search action
    currentRouteName.value = $router.currentRoute.value.name;
    console.log("🚀 ~ setup ~ currentRouteName.value:", currentRouteName.value)
    $store.dispatch('PREVIOUS_ROUTE_NAME', currentRouteName.value);
    // $router.push({
    //     name: "job_seeker_index",
    // });
    emit('update:modalCreateVisible', false);
    emit("job-filter");
};

// const clearText = () => {
//     console.log('clear text')
//     selectedValues.value.text = '';
//     // Update local storage to remove only the 'text' property from 'jobLisitingGuestBrowseFilterObject'
//     const storedValues = JSON.parse(localStorage.getItem('jobLisitingGuestBrowseFilterObject'));
//     if (storedValues) {
//         delete storedValues.text;
//         localStorage.setItem('jobLisitingGuestBrowseFilterObject', JSON.stringify(storedValues));
//     }
// };

const jobListingAttributesForFilter = () => {
    loading.value = true;
    (async () => {
        const existingCvResponse = await $store.dispatch("GET_GUEST_JOB_LISTINGS");
        loading.value = false;
        jobTypes.value = existingCvResponse.data.type;
        if(isAustralia) {
            jobLocations.value = existingCvResponse.data.location;
        }
        taggedSkills.value = existingCvResponse.data.popularSkills;
        if(isUS.value){
            federalPharmacistSupport.value = existingCvResponse.data.federalPharmacistSupport;
        }
    })();
}

const updateAddressData = (addressData) => {
    selectedValues.jobLocation = '';
    selectedValues.value.jobLocation = addressData.formatted_address;
    selectedValues.value.latitude = addressData.latitude;
    selectedValues.value.longitude = addressData.longitude;
};

const setAddress = () => {
    selectedValues.value.jobLocation = '';
    selectedValues.value.latitude = '';
    selectedValues.value.longitude = '';
};

// Restore selected values from local storage on component mount
onMounted(() => {
    const storedValues = localStorage.getItem('jobLisitingGuestBrowseFilterObject');
    if (storedValues) {
        const parsedValues = JSON.parse(storedValues);
        selectedValues.value = parsedValues;

        rateType.value = parsedValues.rate.type;

        // Set the sliderValue to the stored value
        sliderValue.value = parseFloat(parsedValues.rate.value);
    }

    jobListingAttributesForFilter()
});

</script>
